      <div class="card-blueprint-container col-12 d-flex justify-content-center align-items-center flex-wrap mb-3 mb-sm-0">
        <div class="col-md-12 col-sm-12">
          <h3 class="category-card-section m-0">{{title}}</h3>
          <p class="description-blueprint-section pt-1 m-0">{{description}}</p>
        </div>
      </div>
